import { render, staticRenderFns } from "./CmsBulkAction.vue?vue&type=template&id=fdb0c8d4&"
import script from "./CmsBulkAction.vue?vue&type=script&lang=js&"
export * from "./CmsBulkAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports